<template>
  <div>
    <q-dialog :visible="isVisible" title="涉及商品/型号" width="70%" :innerScroll="false" :showFooter="false" @close="onCancel">
      <div class="product-detail-content">
        <search-box class="search-box">
          <el-form :inline="true" size="mini" :model="searchForm" ref="searchForm">
            <el-form-item label="商品编码/型号：" prop="skuCode">
              <el-input v-model="searchForm.skuCode" @keyup.enter.native="onSearch"></el-input>
            </el-form-item>
          </el-form>
          <template v-slot:right>
            <el-button class="green-btn" size="mini" @click="onSearch">查询</el-button>
            <el-button class="orange-btn" size="mini" @click="onReset">重置</el-button>
          </template>
        </search-box>

        <div class="table-container">
          <el-table stripe border :header-cell-style="{ backgroundColor: '#F4F8FB' }" :data="tableData.list" height="400" v-loading="loading">
            <el-table-column prop="skuCode" label="商品编码/型号" width="140" show-overflow-tooltip></el-table-column>
            <el-table-column prop="skuName" label="商品名称" min-width="180" show-overflow-tooltip></el-table-column>
            <el-table-column prop="adjustContent" label="调整内容" width="200" show-overflow-tooltip></el-table-column>
            <el-table-column prop="adjustContent" label="设计图详情" width="100">
              <template slot-scope="{ row }">
                <el-button v-if="row.adjustDetailDesc && row.adjustDetailDesc.length" size="mini" type="text" @click="viewImg(row.adjustDetailDesc)">
                  查看
                </el-button>
              </template>
            </el-table-column>
            <el-table-column prop="listContent" label="通栏清单" width="140" show-overflow-tooltip>
              <template slot-scope="{ row }">
                <span
                  v-if="row.listContent && row.listFileUrl"
                  @click="handleDownload(row.listFileUrl, row.listContent)"
                  style="color: #0bb78e; cursor: pointer"
                >
                  {{ row.listContent }}
                </span>
                <span v-else>{{ row.listContent }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="adjustBefore" label="调整前" width="140"></el-table-column>
            <el-table-column prop="adjustAfter" label="调整后" width="140"></el-table-column>
            <el-table-column prop="name" label="调整人" width="200"></el-table-column>
            <el-table-column prop="creationDate" label="调整时间" width="160"></el-table-column>
          </el-table>

          <div class="pagination-container">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="tableData.pageNum"
              :page-sizes="[30, 60, 90]"
              :page-size="tableData.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              background
              :total="tableData.total"
            ></el-pagination>
          </div>
        </div>
      </div>

      <div class="footer-buttons">
        <el-button @click="onCancel">关闭</el-button>
      </div>
    </q-dialog>
    <appeal-Review :visible.sync="isShowAppealReview" v-if="isShowAppealReview" :appealReason="appealReason" />
  </div>
</template>

<script>
import appealReview from './appealReview';
export default {
  name: 'ProductDetailDialog',
  components: { appealReview },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    rowData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
  },
  data() {
    return {
      loading: false,
      searchForm: {
        skuCode: '',
      },
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      isShowAppealReview: false,
      appealReason: '',
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },

    onSearch() {
      this.tableData.pageNum = 1;
      this.init();
    },

    onReset() {
      this.searchForm = {
        skuCode: '',
      };
      this.tableData.pageNum = 1;
      this.init();
    },

    init() {
      this.loading = true;
      let data = {
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
        filterData: {
          noticeNo: this.rowData.noticeNo,
          skuCode: this.searchForm.skuCode,
        },
      };
      this.searchFormData = data;
      this.$q.goods
        .skuDetailPage({ data: data })
        .then((res) => {
          if (res.code == 200) {
            this.tableData.list = res.data.list;
            this.tableData.total = res.data.total;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init();
    },

    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init();
    },
    // 查看设计图
    viewImg(appealReason) {
      this.isShowAppealReview = true;
      this.appealReason = appealReason;
    },
    // 下载文件（解决跨域下载问题）
    async handleDownload(url, fileName) {
      try {
        const loading = this.$loading({
          lock: true,
          text: '下载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        });
        const response = await fetch(url);
        const blob = await response.blob();
        const objectUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = objectUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(objectUrl);
        loading.close();
      } catch (error) {
        this.$message.error('下载失败');
        console.error('下载失败:', error);
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.product-detail-content
  .search-box
    margin-bottom 15px
    >>> .el-input
      width 200px !important

  .table-container
    .pagination-container
      text-align right
      margin-top 15px

.footer-buttons
  text-align center
  padding 15px 0
  margin-top 15px

>>> .el-dialog 
  margin-top 50px !important
</style>
